/**
 *
 * Asynchronously loads the component for NetworthGrowthBar
 *
 */

import { lazyLoad } from 'utils/loadable';

export const NetworthGrowthBar = lazyLoad(
  () => import('./index'),
  module => module.NetworthGrowthBar,
);
